const AlertMessage = ({message}) => {
    return (
        <div className="text-red-400">
            ({message})
        </div>
    )
}

export default AlertMessage;